import React, { useEffect, useState } from 'react';
import { Table } from "react-bootstrap";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

//Actions
import { item as pesquisasubitems } from '../../../../actions/produto/item';
import { pesquisaPedidosItens as pesquispedidos } from '../../../../actions/produto/pedidosItens';

import { getEvento } from '../../../../utils/eventosession';
import { getUserGeren } from "../../../../utils/authusuariogerenciamento";

const Graficos = (props) => {

    const [evento,setEvento] = useState({});
    const [pedidos,setPedidos] = useState([]);

    const user = getUserGeren();
    
    const handleCarregaPedidos = async () => {
        
        const params = {
            idpromotora: evento.idpromotora,
            idevento: evento.idevento
        }
        
        const prods = await props.pesquisasubitems(params);
        
        
        let idsprods = [];
        if(prods&&prods.length){
            prods.forEach(itens => {
                idsprods.push(itens.idsubitems);
            });
        }
        
        setPedidos(await props.pesquispedidos({
            ...params,
            whereInItens: JSON.stringify(idsprods),
            whereInStatusPedido: JSON.stringify([6]),
            filtro_campos: "idparalelo,idsubitems,portugues,idfisica"
        }))
    }

    useEffect(() => {
        setEvento(getEvento());
    },[props.eventoSelecionado]);

    useEffect(() => {
        if(evento&&evento.idevento){
            handleCarregaPedidos();
        }
    }, [evento]);

    if(user.id === 10279){
        return null;
    }

    let total = 0;
    return (
        <Table striped bordered hover>
            <thead>
                <tr>
                <th>Produto</th>
                <th>Quantidade</th>
                </tr>
            </thead>
            <tbody>
                {pedidos&&pedidos.map((itens, index)=> {
                    
                    let chave = null;
                    const result_filtro_prods_repetidos = itens.itenescolhido.filter(itensprods => {
                        if(itensprods.idsubitems+""+itensprods.pedido.idfisica === chave){
                            chave = itensprods.idsubitems+""+itensprods.pedido.idfisica;
                            return false;
                        }else{
                            chave = itensprods.idsubitems+""+itensprods.pedido.idfisica;
                            return true;
                        }
                    });

                    total += result_filtro_prods_repetidos.length;

                    if(!itens.itenescolhido.length){
                        return null;
                    }
                    return (
                        <tr key={index}>
                        <td>{itens.portugues}</td>
                        <td>{result_filtro_prods_repetidos.length}</td>
                        </tr>
                    );
                })}                
            </tbody>
            <tfoot>
                <tr>
                    <th>
                        Total
                    </th>
                    <th>{total}</th>
                </tr>
            </tfoot>
        </Table>
    )
    
}

const mapStateToProps = (state) => {
    return {
        pendingTasks: state.pendingTasks,
        eventoSelecionado: state.reducerEventoSelecionado
    }
}

export default connect(mapStateToProps,{pesquispedidos,pesquisasubitems})(withRouter(Graficos));